var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1190_572)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0781 28.9295V18.4295H27.0781V28.4295C26.6781 30.0295 25.9114 30.4295 25.5781 30.4295H14.0781C12.8781 30.4295 12.2448 29.4295 12.0781 28.9295Z",
    fill: "#2f67ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0781 15.9295H10.0781C9.67811 13.9295 10.9114 12.7628 11.5781 12.4295H17.0781C19.0781 8.02947 21.5781 10.5961 22.5781 12.4295H27.5781C29.1781 12.8295 29.2448 14.9295 29.0781 15.9295Z",
    fill: "#2f67ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0781 28.9295V18.4295H27.0781V28.4295C26.6781 30.0295 25.9114 30.4295 25.5781 30.4295H14.0781C12.8781 30.4295 12.2448 29.4295 12.0781 28.9295Z",
    stroke: "#2f67ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0781 15.9295H10.0781C9.67811 13.9295 10.9114 12.7628 11.5781 12.4295H17.0781C19.0781 8.02947 21.5781 10.5961 22.5781 12.4295H27.5781C29.1781 12.8295 29.2448 14.9295 29.0781 15.9295Z",
    stroke: "#2f67ca"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1190_572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormDelete);
export default __webpack_public_path__ + "static/media/FormDelete.b591e71ba8288e072a4670c43fbe7b67.svg";
export { ForwardRef as ReactComponent };